import {
  ApolloError,
  LazyQueryExecFunction,
  OperationVariables,
  QueryResult,
  useLazyQuery,
} from '@apollo/client'
import { IEnrollment } from '@dtos/Enrollment'
import {
  GET_PATH_ENROLLMENT,
  GET_PATH_ENROLLMENT_PROGRESS_CARD,
} from './queries/getPathEnrollment'
import { IOrdenationInput, IPaginationInput } from '@dtos/Pagination'

interface IUsePathProgressCardParams {
  id: number
  courseIds: number[] | null
  offset: number
  limit: number
}

export const usePath = (
  id: string,
  ordenation: IOrdenationInput,
  pagination: IPaginationInput,
  options?: { skip?: boolean },
) => {
  const [getEnrollmentPath, { data, loading, error, called }] = useLazyQuery(
    GET_PATH_ENROLLMENT,
    {
      variables: { id, ordenation, pagination },
      skip: options?.skip || !id,
    },
  )

  return { data, loading, error, getEnrollmentPath, called } as {
    data: IEnrollment | null
    loading: boolean
    error: ApolloError
    called: boolean
    getEnrollmentPath: LazyQueryExecFunction<
      { enrollment: IEnrollment },
      OperationVariables
    >
  }
}

export const usePathProgressCard = ({
  id,
  courseIds,
  offset,
  limit,
}: IUsePathProgressCardParams) => {
  const [getProgressCard, { data, loading, error, called }] = useLazyQuery(
    GET_PATH_ENROLLMENT_PROGRESS_CARD,
    {
      variables: { id, courseIds, offset, limit },
    },
  )

  return { getProgressCard, data, loading, error, called } as {
    getProgressCard: (
      id: number,
      courseIds: number[] | null,
      offset: number,
      limit: number,
    ) => Promise<QueryResult<{ enrollment: IEnrollment }, OperationVariables>>
    data: IEnrollment | null
    loading: boolean
    error: ApolloError
    called: boolean
  }
}
